import VideoTutorial from "../../components/VideoTutorial/VideoTutorial";
import { useTranslation } from "react-i18next";

const Tutorials = () => {
    const { t } = useTranslation();

    return (
        <section id="redeem-tutorials" className="container mt-7">
            <h1 className="mb-8">{t("home.howToUse")}</h1>
            <div className="tutorials-container">
                <div className="tutorials-cell">
                    <h2>
                        {t("home.glovoApp")}
                    </h2>
                    <VideoTutorial name='Glovo' title={false} />
                </div>
                <div className="tutorials-cell">
                    <h2>
                        {t("home.digInApp")}
                    </h2>
                    <VideoTutorial name='DIGin' title={false} />
                </div>
            </div>
            <a href="#buy-voucher" className="secondary-button goToTop">
                {t("home.buyVoucher")}
           <img alt="" className="ml-3" src="assets/icons/arrow-top-primary-color.svg" />
            </a>
        </section>
    );
};

export default Tutorials;
